<div class="grid-container margin-top" >    
    <ag-grid-angular class="data-grid  full-page" [rowData]="data$ | async" [gridOptions]="gridOptions" aria-label="Organization Mass Mailing">
    </ag-grid-angular>
</div>